var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPackageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.485 3.10085L5.36 0.843819C5.24978 0.782921 5.12592 0.750977 5 0.750977C4.87408 0.750977 4.75022 0.782921 4.64 0.843819L0.515 3.10179C0.397198 3.16624 0.298861 3.26114 0.230259 3.37658C0.161656 3.49202 0.125305 3.62376 0.125 3.75804V8.24116C0.125305 8.37545 0.161656 8.50718 0.230259 8.62262C0.298861 8.73806 0.397198 8.83296 0.515 8.89741L4.64 11.1554C4.75022 11.2163 4.87408 11.2482 5 11.2482C5.12592 11.2482 5.24978 11.2163 5.36 11.1554L9.485 8.89741C9.6028 8.83296 9.70114 8.73806 9.76974 8.62262C9.83834 8.50718 9.87469 8.37545 9.875 8.24116V3.75851C9.87495 3.62399 9.83871 3.49195 9.7701 3.37625C9.70148 3.26054 9.60301 3.16542 9.485 3.10085ZM5 1.50007L8.76594 3.56257L7.37047 4.32663L3.60406 2.26413L5 1.50007ZM5 5.62507L1.23406 3.56257L2.82312 2.69257L6.58906 4.75507L5 5.62507ZM0.875 4.21882L4.625 6.27101V10.2924L0.875 8.24163V4.21882ZM9.125 8.23976L5.375 10.2924V6.27288L6.875 5.4521V7.12507C6.875 7.22453 6.91451 7.31991 6.98483 7.39023C7.05516 7.46056 7.15054 7.50007 7.25 7.50007C7.34946 7.50007 7.44484 7.46056 7.51517 7.39023C7.58549 7.31991 7.625 7.22453 7.625 7.12507V5.04148L9.125 4.21882V8.23929V8.23976Z",
    fill: "#343330"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackageIcon);
export default __webpack_public_path__ + "static/media/package-icon.c9343e4a18cef7692e79b1861b966ea6.svg";
export { ForwardRef as ReactComponent };